import { render, staticRenderFns } from "./AnalyticsView.vue?vue&type=template&id=2dd97fd6&scoped=true"
import script from "./AnalyticsView.vue?vue&type=script&lang=js"
export * from "./AnalyticsView.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsView.vue?vue&type=style&index=0&id=2dd97fd6&prod&lang=scss&scoped=true"
import style1 from "./AnalyticsView.vue?vue&type=style&index=1&id=2dd97fd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd97fd6",
  null
  
)

export default component.exports